import React from 'react'

function EmbeddedSite({link, scroll}) {
  return (
    <iframe
      src={link}
      title="Site Launcher"
      width="100%"
      height="400px"
      className='rounded-lg border border-gray-700 shadow-[0_0_16px_rgba(255,45,120,0.15)]'
      sandbox="allow-scripts allow-same-origin"
      scrolling={scroll}
    />
  );
}

function MyButton({link}) {
  return (
    <a href={link} target="_blank" rel="noopener noreferrer">
      <button className="bg-gradient-to-r from-pink-500 to-violet-500 text-white font-bold px-5 py-2 rounded-full shadow-[0_0_16px_rgba(255,45,120,0.3)] hover:scale-105 transition-all duration-200">
        Launch Website
      </button>
    </a>
  );
}

const projects = [
  {
    title: 'Careless Sports',
    description: 'Sports content site built with React and Node.js',
    link: 'https://carelesssports.wamoody.com',
    scroll: 'yes',
  },
  {
    title: 'FloriqAI',
    description: 'AI-powered application',
    link: 'https://floriqai.com',
    scroll: 'yes',
  },
  {
    title: 'CS Fabrications',
    description: 'Custom fabrications business website',
    link: 'https://csfabrications.com',
    scroll: 'yes',
  },
  {
    title: 'Ecommerce',
    description: 'Full-stack clothing store with cart, checkout, and admin panel',
    link: 'https://ecom.wamoody.com',
    scroll: 'yes',
  },
  {
    title: 'Calculator',
    description: 'Clean calculator app, pure frontend',
    link: 'https://calc.wamoody.com',
    scroll: 'no',
  },
  {
    title: 'StreamWest',
    description: 'Video streaming platform with upload and playback',
    link: 'https://streamwest.wamoody.com',
    scroll: 'yes',
  },
  {
    title: 'Planet Solar Systems',
    description: 'Interactive solar system visualization',
    link: 'https://planet.wamoody.com',
    scroll: 'yes',
  },
]

const WebsiteLaunchers = () => {
  return (
    <div>
      <div className='text-center py-10 mb-4'>
        <h2 className='font-black text-4xl bg-gradient-to-r from-pink-500 to-cyan-400 bg-clip-text text-transparent'>
          Projects
        </h2>
        <div className='mx-auto mt-2 h-[2px] w-16 rounded-full bg-gradient-to-r from-pink-500 to-cyan-400' />
      </div>
      <div className='grid items-start justify-center w-full gap-6 grid-cols-1 md:grid-cols-2'>
        {projects.map(({ title, description, link, scroll }) => (
          <div key={title} className="flex flex-col rounded-2xl border border-gray-700/60 bg-[#1a1a1a] overflow-hidden shadow-[0_0_20px_rgba(255,45,120,0.08)] hover:shadow-[0_0_30px_rgba(255,45,120,0.2)] transition-shadow duration-300">
            <div className="px-4 pt-4 pb-2">
              <p className="font-bold text-base text-white">{title}</p>
              <p className="text-gray-400 text-sm mt-0.5">{description}</p>
            </div>
            <div className="px-4">
              <EmbeddedSite link={link} scroll={scroll} />
            </div>
            <div className="px-4 py-4">
              <MyButton link={link} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default WebsiteLaunchers
